import { useState } from 'react';
import { getFromStorage } from '../../../../../../lib/storage';
import { Segmented } from 'antd';
import HumanScribeStatus from './HumanScribeStatus';

const HumanScribe = () => {
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('HumanScribeActiveSegment') || 'Status';
  });

  const HumanScribeButton = [
    {
      label: 'Status',
      isActive: activeButton === 'Status',
      onClick: () => setActiveButton('Status'),
    },
  ];

  return (
    <div className={`page-wrapper`}>
      <div className="lg:flex gap-3 justify-between py-3 px-1 items-center ">
        <div className="lg:flex rounded-lg w-fit">
          <Segmented
            options={HumanScribeButton.map((button) => ({
              label: button.label,
              value: button.label,
            }))}
            value={activeButton}
          />
        </div>
      </div>
      <div>{activeButton === 'Status' && <HumanScribeStatus />}</div>
    </div>
  );
};

export default HumanScribe;
